// src/store/modules/landing-page.js
import { GET_PERSONS } from '@/store/action-types';
import { SET_PERSONS } from '@/store/mutation-types';
import personsModel from '@/models/persons/persons'; 

export default {
  namespaced: true,
  actions: {

    async [GET_PERSONS]({ commit }) {
      commit(SET_PERSONS, await personsModel.getAll());
    },
  },
  mutations: {
    [SET_PERSONS](state, persons) {
      state.persons = { ...persons };
    },
  },
  // We initialize the state with
  // an empty LandingPage object.
  state: {
    persons: [],
  },
};